import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ContentLoader from "react-content-loader";
import MaterialTable from "material-table";
import jsPDF from "jspdf";
import Tooltip from "@tippyjs/react";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'


import ViewAmortService from "../../../../services/contract/amort/viewAmortService";
import DetailsContarctService from "../../../../services/contract/detailsContractService";
import Helper from "../../../../Helper";
import { getTrans as t } from "../../../../Localization/translations";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import ContractShortview from "../contractshortview";

function ViewAmortSchedules({ customerPermission }) {
  const [items, setItems] = useState([]);
  const [amortizationschedule, setAmortizationSchedule] = useState([]);
  const [customer_name, setCustomer_Name] = useState("");
  const [contract_number, setContract_number] = useState("");
  const [start_date, setStart_date] = useState("");
  const [contract_term, setContract_term] = useState("");
  const [contract_type, setContract_type] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [payment_start_date, setPaymentStart_date] = useState("");
  const [status, setStatus] = useState("");
  const [financed_amount, setFinanced_amount] = useState("");
  const [deposit_amount, setDesposit_amount] = useState("");
  const [total_deperication, setTotalDeperication] = useState(0);
  const [iir, setIir] = useState("");
  const [total_income, setTotalIncome] = useState(0);
  const [one_time_fee, setOne_Time_Fee] = useState("");
  const [tax_rate_fee, setTax_Rate_Fee] = useState("");
  const [tax_rate_rent, setTax_Rate_Rent] = useState("");
  const [totalrent, setTotalRent] = useState("");
  const [payment_rent_sum, setPaymentRentSum] = useState("");
  const [one_time_fee_sum, setOneTimeFeeSum] = useState("");
  const [totalContract, setTotalContract] = useState("");
  const [amount_billed, setAmount_billed] = useState("");
  const [amount_unbilled, setAmount_unbilled] = useState("");
  const [amount_due, setAmount_due] = useState("");
  const [duedate, setDuedate] = useState("");
  const [nextdue_amt, setNextdue_amt] = useState("");
  const [loading, setLoading] = useState(true);
  const [no_of_payments, setPayments] = useState("");
  const [no_of_periods, setPeriods] = useState("");
  const [loanamount, setLoanAmount] = useState("");
  const [paymentstartdate, setpaymentStartdate] = useState("");
  const [partyid, setPartyid] = useState("");
  const [key, setKey] = useState([]);
  const [extrafiledcontract, setExtraFiled] = useState([]);
  const [contract, setConract] = useState([]);
  const { state } = useLocation();

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existcontract);
    })
  };

  const ACCURED = {
    Y: "Yes",
    N: "No",
  };

  useEffect(() => {
    getExtrafiled();
    DetailsContarctService.getContractDetails(state).then((response) => {
      setKey(response.data);
      setCustomer_Name(response.data.Contract.customer_name);
      setContract_number(response.data.Contract.contract_number);
      setStart_date(response.data.Contract.start_date);
      setContract_term(response.data.Contract.contract_term);
      setContract_type(response.data.Contract.contract_type);
      setEnd_date(response.data.Contract.end_date);
      setStatus(response.data.Contract.status);
      setFinanced_amount(response.data.Contract.financed_amount);
      setDesposit_amount(response.data.Contract.deposit_amount);
      setOne_Time_Fee(response.data.Contract.one_time_fee);
      setTax_Rate_Fee(response.data.Contract.tax_rate_fee);
      setTax_Rate_Rent(response.data.Contract.tax_rate_rent);
      setPaymentStart_date(response.data.Contract.paymentstartdate);
      setTotalRent(response.data.totalRent);
      setPayments(response.data.no_of_payments.no_of_payments);
      setPeriods(response.data.no_of_periods.periods);
      setIir(response.data.irr);
      setTotalIncome(response.data.total_income);
      setTotalContract(response.data.totalContract);
      setAmount_billed(response.data.amount_billed);
      setAmount_unbilled(response.data.amount_unbilled);
      setNextdue_amt(response.data.nextdue_amt);
      setAmount_due(response.data.amount_due);
      setDuedate(response.data.duedate);
      setpaymentStartdate(response.data.Contract.paymentstartdate);
      setPartyid(response.data.Contract.party);
      setLoanAmount(response.data.Contract.loanamount);
      setConract(response.data.Contract);
      setOneTimeFeeSum(response.data.one_time_fee_sum)
      setPaymentRentSum(response.data.payment_rent_sum)
      setTotalDeperication(response.data.total_depriciation)
      setLoading(false);
    })
    handelDefault();
    handelDefaults();
  }, []);

  const handelDefault = () => {
    ViewAmortService.getAmortDetails(state).then((response) => {
      setItems(response.data);
    })
  };
  const handelDefaults = () => {
    ViewAmortService.getAmortizationDetails(state).then((response) => {
      setAmortizationSchedule(response.data);
    })
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === 'payment_amount') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else if (columnDef.field === 'beginbv') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else if (columnDef.field === 'income') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else if (columnDef.field === 'capital_recovery') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else if (columnDef.field === 'book_depriciation') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else if (columnDef.field === 'endbv') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else if (columnDef.field === 'incomerecognized') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else {
        alignmentStyles[index] = { halign: 'left' }; // Left align for other fields
      }
    });
    return alignmentStyles;
  }

  return (
    <>
      {loading === false ? (
        <div className="">
          {/* <ContractShortview customerPermission={customerPermission} contract={contract}/> */}
          <div className="pt-2">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-md-10">
                    {/* <div className="col text-left"></div> */}
                    {/* <div className="row"> */}
                    <div className=" row">
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <label className="sub-title tc">
                          {t("Financed Amount")}{" "}
                          <Tooltip content={t("Amountfinanced_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {financed_amount === 0
                              ? Helper.Amount(financed_amount)
                              : Helper.Amount(financed_amount - deposit_amount)}
                          </span>
                        </div>
                      </div>
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        {/* <label className=" sub-title tc">
                          {t("Total Rent")}{" "}
                          <Tooltip content={t("TotalRent_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label> */}
                        <label className="sub-title tc">
                          {contract_type === "Loan"
                            ? t("Total Payment")
                            : t("Total Rent")}{" "}

                          <Tooltip
                            content={
                              contract_type === "Loan"
                                ? t("Total Payment")
                                : t("TotalRent_Tooltip")
                            }
                          >
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {/* {no_of_payments !== null
                                ? Helper.Amount(totalrent * no_of_payments)
                                : Helper.Amount(totalrent * no_of_periods)} */}
                            {
                              Helper.Amount(payment_rent_sum)
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <label className=" sub-title tc">
                            {t("Tax Rate Fees")}{" "}
                            <Tooltip content={t("TotalRecurringFees_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                            <span className="party-detail-font">
                              {Helper.Amount(tax_rate_fee)}
                            </span>
                          </div>
                        </div> */}
                      {
                        contract_type === "Loan" ?
                          "" :
                          <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                            <label className=" sub-title tc">
                              {t("Total One Time Fees")}{" "}
                              <Tooltip content={t("TotalOneTimeFees_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                              <span className="party-detail-font">
                                {Helper.Amount(one_time_fee_sum)}
                              </span>
                            </div>
                          </div>
                      }
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <label className=" sub-title tc">
                          {t("Total Income")}{" "}
                          <Tooltip content={t("TotalRecurringFees_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {Helper.Amount(key.total_income)}
                          </span>
                        </div>
                      </div>
                    </div>
                     {
                        contract_type == "Loan" ? (
                                                    <>
                                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                            <label className=" col-form-label">
                                                                {t("Interest Rate Type")}{" "}
                                                                <Tooltip
                                                                    content={t("InterestRateType_Tooltip")}
                                                                >
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                                <span className=" view-label p">
                                                                    {(contract.interest_rate_type)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </>
                                            )
                                            : ""
                                        }
                     {
                          contract_type === "Loan" ?
                    <div className=" row">
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                            <label className=" col-form-label">
                                {t("Base Rate")}{" "}
                                <Tooltip content={t("BaseRate_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                            </label>
                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <span className="party-detail-font">
                                    {contract.base_rate ? contract.base_rate : "0.00"}
                                </span>     

                            </div>
                            </div>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                            <label className=" col-form-label">
                                {t("Margin")}{" "}
                            <Tooltip content={t("Margin_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                            </label>
                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <span className=" party-detail-font">
                                    {contract.margin ? contract.margin : "0.00"}
                                </span>     

                            </div>
                            </div>
                            </div>
                            :
                            ""
                        }
                    <div className=" row">
                      {
                        contract_type === "Rental" ?
                          "" :
                          <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                            <label className=" sub-title tc">
                              {t("IRR/Interest p.a.")}{" "}
                              <Tooltip content={t("InterestRate_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                              <span className="party-detail-font">
                                {Helper.Amount(iir)}
                              </span>
                            </div>
                          </div>
                      }
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <label className="sub-title tc">
                          {t("Term (Months)")}{" "}
                          <Tooltip content={t("Term_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {contract_term}
                          </span>
                        </div>
                      </div>
                      {
                        contract_type === "Rental" ?
                          <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                            <span className="sub-title tc">
                              {t("Total Depreciation")}{" "}
                              <Tooltip content={t("Total Depreciation")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </span>
                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                              <span className="party-detail-font">
                                {Helper.Amount(total_deperication)}
                              </span>
                            </div>
                          </div> :
                          ""
                      }
                    </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="" style={{ position: "relative", minHeight: "138vh" }}>

            <div className="row py-2 mt-3" id="payschedule" style={{ marginBottom: "50px" }}>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  overflowX: "auto",
                }}
              >
                <div className="mb-0">
                  <div className="">
                    <div className="p-0">
                      {contract_type === "Rental" ? (
                        <MaterialTable

                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            overflowX: 'auto',
                          }}
                          title={<span>Amort Schedules</span>}
                          columns={[
                            {
                              title: `${t("Date")}`,
                              field: "payment_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                                  <div>
                                    {Helper.DateNormal(rowData.payment_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Peridic Payment Amount")}`,
                              field: "payment_amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Periodic Payment Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {" "}
                                    {rowData.payment_amount !== 0
                                      ? Helper.Amount(rowData.payment_amount)
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Start Date")}`,
                              field: "start_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Start Date")}
                                  </div>
                                  <div>{Helper.DateNormal(rowData.start_date)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("End Date")}`,
                              field: "end_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("End Date")}
                                  </div>
                                  <div>{Helper.DateNormal(rowData.end_date)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("No Of Days")}`,
                              field: "noofdays",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("No Of Days")}
                                  </div>
                                  <div>{rowData.noofdays}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },

                            {
                              title: t("OP Begin"),
                              field: "beginbv",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("OP Begin")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.beginbv)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: t("Income Date"),
                              field: "income_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Income Date")}
                                  </div>
                                  <div>{Helper.DateNormal(rowData.income_date)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            //
                            {
                              title: t("Rental Income"),
                              field: "income",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Rental Income")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.income)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: t("Book Depreciation"),
                              field: "book_depriciation",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Book Depreciation")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {Helper.Amount(rowData.book_depriciation)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: t("OP End"),
                              field: "endbv",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >{t("OP End")}</div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.endbv)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Income Recognized")}`,
                              field: "incomerecognized",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Income Recognized")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {rowData.incomerecognized !== 0
                                      ? Helper.Amount(rowData.incomerecognized)
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Accured")}`,
                              field: "accrued_yn",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Accured")}</div>
                                  <div>{ACCURED[rowData.accrued_yn]}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={amortizationschedule}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 10,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            toolbar: true,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 15, 20, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            exportAllData: true,
                            exportButton: true,
                            exportFileName: "Amortization Schedule",
                            exportCsv: async (columns, data) => {
                              try {
                                const title = "Amortization Schedule";
                                const currentDate = new Date().toLocaleDateString();
                                const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;
                                const csvColumns = columns.map(columnDef => columnDef.title);
                                const csvData = data.map(rowData => {
                                  const rowDataArray = columns.map(columnDef => {
                                    if (columnDef.field === "payment_amount") {
                                      return (
                                        rowData.payment_amount !== 0
                                          ? Helper.Amount(rowData.payment_amount)
                                          : ""
                                      );
                                    } else if (columnDef.field === "beginbv") {
                                      return (rowData.beginbv !== 0 ?
                                        Helper.Amount(rowData.beginbv) : ''
                                      )
                                    } else if (columnDef.field === 'income') {
                                      return (
                                        rowData.income !== 0 ?
                                          Helper.Amount(rowData.income) : ''
                                      )
                                    } else if (columnDef.field === 'book_depriciation') {
                                      return (
                                        rowData.book_depriciation !== 0 ? Helper.Amount(rowData.book_depriciation) : ''
                                      )
                                    } else if (columnDef.field === 'endbv') {
                                      return (
                                        rowData.endbv !== 0 ? Helper.Amount(rowData.endbv) : ''
                                      )
                                    } else if (columnDef.field === 'incomerecognized') {
                                      return (
                                        rowData.incomerecognized !== 0 ? Helper.Amount(rowData.incomerecognized) : ''
                                      )
                                    }
                                    else {
                                      return rowData[columnDef.field];
                                    }
                                  });
                                  return rowDataArray;
                                });

                                const csvRows = [csvColumns, ...csvData];
                                const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                                  return row.map(field => {
                                    if (field === null || field === undefined) {
                                      return '""'; // Represent null values as an empty string in double quotes
                                    }
                                    if (typeof field === 'string' && field.includes(',')) {
                                      return `"${field}"`;
                                    } else {
                                      return field;
                                    }
                                  }).join(',');
                                }).join('\n')}`;
                                // const csvContent = csvRows.map(row => row.join(',')).join('\n');

                                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = 'Amortization Schedule.csv';
                                link.style.display = 'none';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } catch (error) {
                                console.error("Error exporting CSV:", error);

                                // Add this line to see the detailed error information in the console
                                console.error(error.stack);
                              }
                            },
                            exportPdf: (data, columns) => {
                              const doc = new jsPDF();
                              doc.setFont("helvetica", "bold");
                              doc.setFontSize(16);

                              const title = "Amortization Schedule";
                              doc.text(title, 14, 10);

                              doc.setFontSize(12);
                              doc.setFont("helvetica", "normal");
                              const currentDate = new Date().toLocaleDateString();
                              doc.text(`Date : ${currentDate}`, 14, 15);
                              const columnTitles = data.map(
                                (columnDef) => columnDef.title
                              );
                              const space = 22; // Adjust the space value as needed
                              const tableStartY = 5 + space;
                              const pdfData = columns.map((rowData) => {
                                const rowDataArray = data.map((columnDef) => {
                                  if (columnDef.field === "payment_amount") {
                                    return (
                                      rowData.payment_amount !== 0
                                        ? Helper.Amount(rowData.payment_amount)
                                        : ""
                                    );
                                  } else if (columnDef.field === "beginbv") {
                                    return (rowData.beginbv !== 0 ?
                                      Helper.Amount(rowData.beginbv) : ''
                                    )
                                  } else if (columnDef.field === 'income') {
                                    return (
                                      rowData.income !== 0 ?
                                        Helper.Amount(rowData.income) : ''
                                    )
                                  } else if (columnDef.field === 'book_depriciation') {
                                    return (
                                      rowData.book_depriciation !== 0 ? Helper.Amount(rowData.book_depriciation) : ''
                                    )
                                  } else if (columnDef.field === 'endbv') {
                                    return (
                                      rowData.endbv !== 0 ? Helper.Amount(rowData.endbv) : ''
                                    )
                                  } else if (columnDef.field === 'incomerecognized') {
                                    return (
                                      rowData.incomerecognized !== 0 ? Helper.Amount(rowData.incomerecognized) : ''
                                    )
                                  }
                                  else {
                                    return rowData[columnDef.field];
                                  }
                                });
                                return rowDataArray;
                              });
                              // doc.autoTable({
                              autoTable(doc, {
                                head: [columnTitles],
                                body: pdfData,
                                startY: tableStartY, // Adjust the vertical starting position of the table
                                styles: {
                                  cellPadding: 2, // Adjust cell padding
                                  fontSize: 5,
                                },
                                columnStyles: getAlignmentStyles(data) // Apply column alignment styles

                              });

                              doc.save(`Amortization Schedule.pdf`);
                            },
                            actionsColumnIndex: -1,
                          }}
                        />
                      ) : contract_type === "Loan" ? (
                        <MaterialTable
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            overflowX: 'auto',
                          }}
                          title={<span>Amort Schedules</span>}
                          columns={[
                            {
                              title: `${t("Date")}`,
                              field: "payment_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                                  <div>
                                    {" "}
                                    {Helper.DateNormal(rowData.payment_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Payment Amount")}`,
                              field: "payment_amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Payment Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {" "}
                                    {rowData.payment_amount !== 0
                                      ? Helper.Amount(rowData.payment_amount)
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Start Date")}`,
                              field: "start_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Start Date")}
                                  </div>
                                  <div>{Helper.DateNormal(rowData.start_date)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("End Date")}`,
                              field: "end_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("End Date")}
                                  </div>
                                  <div>{Helper.DateNormal(rowData.end_date)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("No Of Days")}`,
                              field: "noofdays",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("No Of Days")}
                                  </div>
                                  <div>{rowData.noofdays}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Interest Date")}`,
                              field: "income_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Interest Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.income_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Begining Principal")}`,
                              field: "beginbv",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Begining Principal")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.beginbv)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Interest")}`,
                              field: "income",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Interest")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.income)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Principal")}`,
                              field: "capital_recovery",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Principal")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {Helper.Amount(rowData.capital_recovery)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Ending Principal")}`,
                              field: "endbv",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Ending Principal")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.endbv)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Interest Recognized")}`,
                              field: "incomerecognized",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Interest Recognized")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {rowData.incomerecognized !== 0
                                      ? Helper.Amount(rowData.incomerecognized)
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Accured")}`,
                              field: "accrued_yn",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Accured")}</div>
                                  <div>{ACCURED[rowData.accrued_yn]}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={amortizationschedule}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              // color: "#008DC1",
                              fontSize: 10,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            toolbar: true,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 15, 20, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            exportAllData: true,
                            exportButton: true,
                            exportFileName: "Amortization Schedule",
                            exportCsv: async (columns, data) => {
                              try {
                                const title = "Amortization Schedule";
                                const currentDate = new Date().toLocaleDateString();

                                const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;
                                const csvColumns = columns.map(columnDef => columnDef.title);
                                const csvData = data.map(rowData => {
                                  const rowDataArray = columns.map(columnDef => {
                                    if (columnDef.field === "payment_amount") {
                                      return (
                                        rowData.payment_amount !== 0
                                          ? Helper.Amount(rowData.payment_amount)
                                          : ""
                                      );
                                    } else if (columnDef.field === "beginbv") {
                                      return (
                                        rowData.beginbv !== 0
                                          ? Helper.Amount(rowData.beginbv)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "income") {
                                      return (
                                        rowData.income !== 0
                                          ? Helper.Amount(rowData.income)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "capital_recovery") {
                                      return (
                                        rowData.capital_recovery !== 0
                                          ? Helper.Amount(rowData.capital_recovery)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "endbv") {
                                      return (
                                        rowData.endbv !== 0
                                          ? Helper.Amount(rowData.endbv)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "incomerecognized") {
                                      return (
                                        rowData.incomerecognized !== 0
                                          ? Helper.Amount(rowData.incomerecognized)
                                          : ""
                                      );
                                    }
                                    else {
                                      return rowData[columnDef.field];
                                    }
                                  });
                                  return rowDataArray;
                                });

                                const csvRows = [csvColumns, ...csvData];
                                const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                                  return row.map(field => {
                                    if (field === null || field === undefined) {
                                      return '""'; // Represent null values as an empty string in double quotes
                                    }
                                    if (typeof field === 'string' && field.includes(',')) {
                                      return `"${field}"`;
                                    } else {
                                      return field;
                                    }
                                  }).join(',');
                                }).join('\n')}`;
                                // const csvContent = csvRows.map(row => row.join(',')).join('\n');

                                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = 'Amortization Schedule.csv';
                                link.style.display = 'none';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } catch (error) {
                                console.error("Error exporting CSV:", error);

                                // Add this line to see the detailed error information in the console
                                console.error(error.stack);
                              }
                            },
                            exportPdf: (data, columns) => {
                              const doc = new jsPDF();
                              doc.setFont("helvetica", "bold");
                              doc.setFontSize(16);

                              const title = "Amortization Schedule";
                              doc.text(title, 14, 10);

                              doc.setFontSize(12);
                              doc.setFont("helvetica", "normal");
                              const currentDate = new Date().toLocaleDateString();
                              doc.text(`Date : ${currentDate}`, 14, 15);
                              const columnTitles = data.map(
                                (columnDef) => columnDef.title
                              );
                              const space = 22; // Adjust the space value as needed
                              const tableStartY = 5 + space;
                              const pdfData = columns.map((rowData) => {
                                const rowDataArray = data.map((columnDef) => {
                                  if (columnDef.field === "payment_amount") {
                                    return (
                                      rowData.payment_amount !== 0
                                        ? Helper.Amount(rowData.payment_amount)
                                        : ""
                                    );
                                  } else if (columnDef.field === "beginbv") {
                                    return (
                                      rowData.beginbv !== 0
                                        ? Helper.Amount(rowData.beginbv)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "income") {
                                    return (
                                      rowData.income !== 0
                                        ? Helper.Amount(rowData.income)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "capital_recovery") {
                                    return (
                                      rowData.capital_recovery !== 0
                                        ? Helper.Amount(rowData.capital_recovery)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "endbv") {
                                    return (
                                      rowData.endbv !== 0
                                        ? Helper.Amount(rowData.endbv)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "incomerecognized") {
                                    return (
                                      rowData.incomerecognized !== 0
                                        ? Helper.Amount(rowData.incomerecognized)
                                        : ""
                                    );
                                  }
                                  else {
                                    return rowData[columnDef.field];
                                  }
                                });
                                return rowDataArray;
                              });
                              // doc.autoTable({
                              autoTable(doc, {
                                head: [columnTitles],
                                body: pdfData,
                                startY: tableStartY, // Adjust the vertical starting position of the table
                                styles: {
                                  cellPadding: 2, // Adjust cell padding
                                  fontSize: 5,
                                },
                                columnStyles: getAlignmentStyles(data) // Apply column alignment styles

                              });

                              doc.save(`Amortization Schedule.pdf`);
                            },
                            actionsColumnIndex: -1,
                          }}
                        />
                      ) : (
                        <MaterialTable
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            overflowX: 'auto',
                          }}
                          title={<span>Amort Schedules</span>}
                          columns={[
                            {
                              title: `${t("Date")}`,
                              field: "payment_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                                  <div>
                                    {" "}
                                    {Helper.DateNormal(rowData.payment_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Payment Amount")}`,
                              field: "payment_amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Payment Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {" "}
                                    {rowData.payment_amount !== 0
                                      ? Helper.Amount(rowData.payment_amount)
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Start Date")}`,
                              field: "start_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Start Date")}
                                  </div>
                                  <div>{Helper.DateNormal(rowData.start_date)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("End Date")}`,
                              field: "end_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("End Date")}
                                  </div>
                                  <div>{Helper.DateNormal(rowData.end_date)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("No Of Days")}`,
                              field: "noofdays",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("No Of Days")}
                                  </div>
                                  <div>{rowData.noofdays}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Income Date")}`,
                              field: "income_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Income Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.income_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Begin Bv")}`,
                              field: "beginbv",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Begin Bv")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.beginbv)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Income")}`,
                              field: "income",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >{t("Income")}</div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.income)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Capital Recovery")}`,
                              field: "capital_recovery",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Capital Recovery")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {Helper.Amount(rowData.capital_recovery)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("End Bv")}`,
                              field: "endbv",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >{t("End Bv")}</div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.endbv)}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Income Recognized")}`,
                              field: "incomerecognized",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Income Recognized")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {rowData.incomerecognized !== 0
                                      ? Helper.Amount(rowData.incomerecognized)
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Accured")}`,
                              field: "accrued_yn",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Accured")}</div>
                                  <div>{ACCURED[rowData.accrued_yn]}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={amortizationschedule}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 10,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            toolbar: true,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 15, 20, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            exportAllData: true,
                            exportButton: true,
                            exportFileName: "Amortization Schedule",
                            exportCsv: async (columns, data) => {
                              try {
                                const title = "Amortization Schedule";
                                const currentDate = new Date().toLocaleDateString();

                                const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;
                                const csvColumns = columns.map(columnDef => columnDef.title);
                                const csvData = data.map(rowData => {
                                  const rowDataArray = columns.map(columnDef => {
                                    if (columnDef.field === "payment_amount") {
                                      return (
                                        rowData.payment_amount !== 0
                                          ? Helper.Amount(rowData.payment_amount)
                                          : ""
                                      );
                                    } else if (columnDef.field === "beginbv") {
                                      return (
                                        rowData.beginbv !== 0
                                          ? Helper.Amount(rowData.beginbv)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "income") {
                                      return (
                                        rowData.income !== 0
                                          ? Helper.Amount(rowData.income)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "capital_recovery") {
                                      return (
                                        rowData.capital_recovery !== 0
                                          ? Helper.Amount(rowData.capital_recovery)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "endbv") {
                                      return (
                                        rowData.endbv !== 0
                                          ? Helper.Amount(rowData.endbv)
                                          : ""
                                      );
                                    }
                                    else if (columnDef.field === "incomerecognized") {
                                      return (
                                        rowData.incomerecognized !== 0
                                          ? Helper.Amount(rowData.incomerecognized)
                                          : ""
                                      );
                                    }
                                    else {
                                      return rowData[columnDef.field];
                                    }
                                  });
                                  return rowDataArray;
                                });

                                const csvRows = [csvColumns, ...csvData];
                                const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                                  return row.map(field => {
                                    if (field === null || field === undefined) {
                                      return '""'; // Represent null values as an empty string in double quotes
                                    }
                                    if (field.includes(',')) {
                                      return `"${field}"`;
                                    } else {
                                      return field;
                                    }
                                  }).join(',');
                                }).join('\n')}`;
                                // const csvContent = csvRows.map(row => row.join(',')).join('\n');

                                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = 'Amortization Schedule.csv';
                                link.style.display = 'none';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } catch (error) {
                                console.error("Error exporting CSV:", error);

                                // Add this line to see the detailed error information in the console
                                console.error(error.stack);
                              }
                            },
                            exportPdf: (data, columns) => {
                              const doc = new jsPDF();
                              doc.setFont("helvetica", "bold");
                              doc.setFontSize(16);

                              const title = "Amortization Schedule";
                              doc.text(title, 14, 10);

                              doc.setFontSize(12);
                              doc.setFont("helvetica", "normal");
                              const currentDate = new Date().toLocaleDateString();
                              doc.text(`Date : ${currentDate}`, 14, 15);
                              const columnTitles = data.map(
                                (columnDef) => columnDef.title
                              );
                              const pdfData = columns.map((rowData) => {
                                const rowDataArray = data.map((columnDef) => {
                                  if (columnDef.field === "payment_amount") {
                                    return (
                                      rowData.payment_amount !== 0
                                        ? Helper.Amount(rowData.payment_amount)
                                        : ""
                                    );
                                  } else if (columnDef.field === "beginbv") {
                                    return (
                                      rowData.beginbv !== 0
                                        ? Helper.Amount(rowData.beginbv)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "income") {
                                    return (
                                      rowData.income !== 0
                                        ? Helper.Amount(rowData.income)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "capital_recovery") {
                                    return (
                                      rowData.capital_recovery !== 0
                                        ? Helper.Amount(rowData.capital_recovery)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "endbv") {
                                    return (
                                      rowData.endbv !== 0
                                        ? Helper.Amount(rowData.endbv)
                                        : ""
                                    );
                                  }
                                  else if (columnDef.field === "incomerecognized") {
                                    return (
                                      rowData.incomerecognized !== 0
                                        ? Helper.Amount(rowData.incomerecognized)
                                        : ""
                                    );
                                  }
                                  else {
                                    return rowData[columnDef.field];
                                  }
                                });
                                return rowDataArray;
                              });
                              const space = 22; // Adjust the space value as needed
                              const tableStartY = 5 + space;
                              // doc.autoTable({
                              autoTable(doc, {
                                head: [columnTitles],
                                body: pdfData,
                                startY: tableStartY, // Adjust the vertical starting position of the table
                                styles: {
                                  cellPadding: 2, // Adjust cell padding
                                  fontSize: 5,
                                },
                                columnStyles: getAlignmentStyles(data) // Apply column alignment styles

                              });

                              doc.save(`Amortization Schedule.pdf`);
                            },
                            actionsColumnIndex: -1,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default ViewAmortSchedules;
